import * as React from 'react';
import { Form, Modal } from 'react-bootstrap';

interface ILabSimUserProductsProps {

}

interface ILabSimUserProductsState {
    error: string;
    fetching: boolean;
    completed: boolean;
    productExpirationList?: Array<IProductExpiration>;
    checkboxSelected: boolean;
    showModal: boolean;
}

interface IProductExpiration {
    title: string;
    isInternational: boolean;
    courseId: number;
    expirationDateStr: string;
}

interface IProductExpirationListResponse {
    productExpirationList: Array<IProductExpiration>;
    error: string;
}

export default class LabSimUserProducts extends React.PureComponent<ILabSimUserProductsProps, ILabSimUserProductsState> {
    _dProducts: HTMLDivElement | undefined | null;
    _masterDtInput: HTMLInputElement | undefined | null;

    constructor(props: ILabSimUserProductsProps) {
        super(props);
        this.state = { error: "", checkboxSelected: false, fetching: true, completed: false, showModal: false };
    }

    async componentDidMount() {
        let response = await fetch(`/api/labsim/products/expirationdates${window.location.search}`);
        let data = await response.json() as IProductExpirationListResponse;
        if (data.error)
            this.setState({ error: `Unable to retrieve the product list: ${data.error}. Please close and try again, or contact IT for help.` });
        else
            this.setState({ fetching: false, productExpirationList: data.productExpirationList });
    }

    setDates() {
        if (this._dProducts != null && this._masterDtInput != null) {
            let elements = this._dProducts.getElementsByTagName("input");
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].type === "checkbox" && elements[i].checked) {
                    let dtName = elements[i].name.replace("cbx", "dt");
                    let dtElement = document.getElementsByName(dtName);
                    if (dtElement != null && dtElement.length > 0)
                        (dtElement[0] as HTMLInputElement).value = this._masterDtInput.value;
                }
            }
            this.setState({ checkboxSelected: false });
        }
        this.toggleModal();
    }

    save_Click() {
        let arr = [] as any;
        if (this._dProducts != null) {
            let elements = this._dProducts.getElementsByTagName("input");
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].type === "date") {
                    let courseId = elements[i].getAttribute("data-course-id");
                    if (courseId != null) {
                        let originalValue = elements[i].getAttribute("original-value");
                        let expirationDateStr = elements[i].value;
                        if (expirationDateStr === '' && originalValue === null)
                            continue;
                        if (originalValue !== expirationDateStr)
                            arr.push({ courseId: parseInt(courseId), expirationDateStr: expirationDateStr });
                    }
                }
            }
        }
        if (arr.length === 0) {
            this.setState({ fetching: false, error: "No changes detected. Nothing to save." });
            return;
        }

        this.setState({ fetching: true, error: "" }, async () => {
            let response = await fetch(`/api/labsim/products/expirationdates${window.location.search}`, {
                method: "PUT",
                headers: { "content-type": "application/json" },
                body: JSON.stringify(arr)
            });
            let data = await response.json();
            if (data.error)
                this.setState({ fetching: false, error: `Unable to save the license expiration dates: ${data.error} Please try again, or contact IT for help.` });
            else
                this.setState({ fetching: false, error: "", completed: true });
        });
    }

    cancelForm() {
        window.parent.postMessage(JSON.stringify({ "action": "CANCEL" }), "*");
    }

    closeForm() {
        window.parent.postMessage(JSON.stringify({ "action": "DONE" }), "*");
    }

    formatDate(date: Date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    onDateChange(e: any) {
        try {
            let d = new Date(Date.parse(e.target.value));
            if (d < (new Date()))
                e.target.value = this.formatDate(new Date());
        }
        catch (errorIgnored) { }
    }

    updateMultiSelectStatus() {
        if (this._dProducts != null) {
            let checked = false;
            let elements = this._dProducts.getElementsByTagName("input");
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].type === "checkbox" && elements[i].checked) {
                    checked = true;
                    break;
                }
            }
            this.setState({checkboxSelected: checked});
        }
    }

    toggleModal() {
        this.setState({ showModal: !this.state.showModal }, () => {
            this.updateMultiSelectStatus();
        });
    }

    render() {
        return <div>
            <Modal show={this.state.showModal}>
                <Modal.Header>
                    <Modal.Title>Set date for selected items</Modal.Title>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>Choose a date to use for the selected items</p>
                    <div className="card-body bg-light p-4">Date: <Form.Control ref={(val: HTMLInputElement) => { this._masterDtInput = val }} className="form-control-sm" type="date" placeholder="MM/DD/YYYY" /></div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { this.toggleModal() }}>Cancel</button>
                    <button type="button" className="btn btn-primary" onClick={() => { this.setDates(); }}>Save</button>
                </Modal.Footer>
            </Modal>
            {this.state.error !== "" && <div className="alert alert-danger text-center" id="cAlert">
                <label>{this.state.error}</label>
            </div>}
            {this.state.fetching && <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>}
            {!this.state.fetching && !this.state.completed && <div className="container" id="cProducts">
                    <p>Set an expiration date for those products this contact should be able to use.</p>
                    <div className="container d-flex mb-2 justify-content-end">
                        <button type="button" className="float-right btn btn-primary" id="bSetDate1" disabled={!this.state.checkboxSelected} onClick={() => { this.toggleModal() }}>Set date on selected products ...</button>
                        <button type="submit" className="float-right btn btn-primary ml-2" id="btnSave1" onClick={() => { this.save_Click() }}>Save changes</button>
                        <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelForm() }}>Cancel</button>
                    </div>
                    <div className="card">
                        <div className="card-body list-group bg-light p-4" id="dProducts" ref={(val) => { this._dProducts = val }}>
                            {this.state.productExpirationList != null && <>
                                {this.state.productExpirationList.map((p, idx) => {
                                    return <div key={idx} className="list-group-item d-flex align-items-center">
                                        <input name={`cbx${idx}`} type="checkbox" className="ml-0 mr-2" onChange={() => { this.updateMultiSelectStatus() }} />
                                        <label style={{ "marginBottom": "0", "maxWidth": "500px", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>{p.title}</label>
                                        <div className="ml-auto">
                                            <Form.Control name={`dt${idx}`} type="date" placeholder="MM/DD/YYYY" defaultValue={p.expirationDateStr} original-value={p.expirationDateStr} data-course-id={p.courseId} />
                                        </div>
                                    </div>;
                                })}
                            </>}
                        </div>
                    </div>
                    <div className="container mt-2">
                        <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelForm() }}>Cancel</button>
                        <button type="submit" className="float-right btn btn-primary ml-2" id="btnSave2" onClick={() => { this.save_Click() }}>Save changes</button>
                        <button type="button" className="float-right btn btn-primary" id="bSetDate2" disabled={!this.state.checkboxSelected} onClick={() => { this.toggleModal() }}>Set date on selected products ...</button>
                    </div>
                </div>}
            {this.state.completed && <div className="container" id="cComplete">
                <div className="alert alert-success" role="alert">These changes have been saved.</div>
                <button type="button" className="float-right btn btn-primary ml-2" onClick={() => { this.closeForm() }}>Done</button>
            </div>}
        </div>;
    }
}